/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
const variations = [{
  name: 'default',
  isDefault: true,
  attributes: {
    buttonText: __('Search'),
    label: __('Search')
  }
}];
export default variations;
//# sourceMappingURL=variations.js.map